/* iceberg-ui */
import { Button } from '@auviknetworks/iceberg-ui';

/* Shared */
import { useFetchPermissions } from 'hooks/dataAccess/Permissions/permissions';

/* React */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InviteUserModal } from '../Modals/InviteUser';

interface AddUserProps {
    rerender: () => void;

    clientId?: string;
    platformTenantId?: string;
    userId?: string;
    isANM?: boolean;
    'data-trackid'?: string;
}

export const AddUser = ({
    rerender,
    clientId,
    platformTenantId,
    userId,
    isANM,
    'data-trackid': dataTrackid
}: AddUserProps) => {
    const { t } = useTranslation();
    const [permission, setPermission] = useState<string | null>(null);

    const [open, setOpen] = useState(false);
    const { loading, permissions } = useFetchPermissions({
        defaultNewUser: true,
        ...(clientId
            ? { includeClients: true, platformTenantId: clientId }
            : {})
    });

    useEffect(() => {
        if (permissions && permissions?.length > 0) {
            const [defaultPermision] = permissions;
            setPermission(defaultPermision.id || null);
        }
    }, [permissions]);

    return (
        <>
            {!loading && (
                <Button
                    data-trackid={`${dataTrackid}_addNewUser`}
                    onClick={() => setOpen(true)}
                    size="small"
                    variant="inverted"
                >
                    {t('Common.add_new_user')}
                </Button>
            )}

            {open && permission && (
                <InviteUserModal
                    clientId={clientId}
                    defaultDropdownOption={permission}
                    isANM={isANM}
                    onClose={() => setOpen(false)}
                    platformTenantId={platformTenantId}
                    rerender={rerender}
                    show={open}
                    userId={userId}
                />
            )}
        </>
    );
};
